var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrinksLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 613.2 370.1",
    style: {
      enableBackground: "new 0 0 613.2 370.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{clip-path:url(#SVGID_4_);}\r\n\t.st3{clip-path:url(#SVGID_6_);}\r\n\t.st4{clip-path:url(#SVGID_8_);}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st6{fill:url(#SVGID_9_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st7{fill:url(#SVGID_10_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st8{fill:url(#SVGID_11_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st9{fill:url(#SVGID_12_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st10{fill:#FDFDFD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.4,164.3h7.4c3.4,0,7.8-0.9,7.8-5.9c0-3.4-1.8-5.9-8.8-5.9h-8.6v45.3h-18.1v-59.4h32.2 c10.4,0,21.8,4.9,21.8,17c0,6.2-2.8,12.7-8.9,14.9c5,1.9,8.8,5.1,8.7,14.8c0,2.9-0.6,8.9,1.7,12.7h-19.5c-1.5-2.5-0.8-6.1-1.1-9.2 c-0.5-5.7,0-11.6-7.3-11.6h-7.6L262.4,164.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.4,
    y: 138.3,
    className: "st0",
    width: 18.7,
    height: 59.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 138.3,
    className: "st0",
    width: 2.4,
    height: 59.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.1,
    y: 138.3,
    className: "st0",
    width: 12.3,
    height: 59.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.6,
    y: 138.3,
    className: "st0",
    width: 9.9,
    height: 59.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.2,
    y: 138.3,
    className: "st0",
    width: 4.9,
    height: 59.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.5,
    y: 138.3,
    className: "st0",
    width: 7.4,
    height: 59.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "322.7,138.3 340.6,138.3 359.4,168.5 359.4,169.4 359.4,138.3 378,138.3 378,197.8 359.4,197.8  340.8,167.7 340.7,165.7 340.7,197.8 322.7,197.8 322.7,138.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "381,138.3 400.5,138.3 400.5,164.9 400.7,164.9 419.1,138.3 441.6,138.3 421.2,166.9 442.4,197.8  418.6,197.8 400.5,170.1 400.5,197.8 381,197.8 381,138.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.6,184h-10.7v-31.2h9.7c3.6,0,6.7,1.4,6.7,4.6c0,3.3-2,5.1-6.7,5.1h-6.1l0,11.1h8c4,0,6.7,1.4,6.7,5.2 C221.1,182.8,218.3,184,213.6,184 M228.9,166.2c4.4-2.4,7.9-4.3,7.9-13c0-9.5-7.7-14.9-21.7-14.9h-29.9v59.4h32.1 c10.5,0,21.7-4.4,21.8-18.1C239.1,170.9,234.2,168.1,228.9,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.3,178.2c0,1.5,0.2,2.8,0.7,3.9c1.3,3.6,5.3,4.3,8.7,4.3c3,0,7.6-1,7.6-5.4c0-3.1-2.6-3.9-12.8-6.8 c-9.4-2.7-20.1-5.2-20.1-17.2c0-13.7,11.7-19.6,24-19.6c12.9,0,24.3,4.9,24.8,19.4h-17.3c0.3-2.2-0.7-3.7-2.2-4.7 c-1.5-1.1-3.6-1.5-5.4-1.5c-2.5,0-6.6,0.7-6.6,4c0.3,4.2,8.8,5.2,17.2,7.5c8.4,2.3,16.7,6.2,16.7,17.1c0,15.5-14.2,20.5-27.5,20.5 c-6.7,0-26-2.4-26.1-21.4H454.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "123.5,208.1 129.8,208.1 129.8,217.6 145.9,217.6 145.9,208.1 152.1,208.1 152.1,232 145.9,232  145.9,221.2 129.8,221.2 129.8,232 123.5,232 123.5,208.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.3,220c0,4.6,3.2,9.1,10.8,9.1c7.6,0,10.8-4.5,10.8-9.1c0-4.6-3.2-9.1-10.8-9.1 C163.4,210.9,160.3,215.4,160.3,220 M188.1,220c0,6.8-6.4,12.5-17,12.5c-10.6,0-17-5.7-17-12.5s6.4-12.5,17-12.5 C181.7,207.5,188.1,213.2,188.1,220z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "189.8,208.1 198.1,208.1 207.4,226.8 207.5,226.8 216.5,208.1 224.7,208.1 224.7,232 219.1,232  219.1,213.5 219,213.5 209.7,232 204.8,232 195.5,213.5 195.4,213.5 195.4,232 189.8,232 189.8,208.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "227,208.1 252.5,208.1 252.5,211.7 233.2,211.7 233.2,218 251.1,218 251.1,221.4 233.2,221.4  233.2,228.4 252.9,228.4 252.9,232 227,232 227,208.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.9,224c0,3.7,4,5.1,9,5.1c5.5,0,7.5-1.8,7.5-3.6c0-1.8-1.5-2.6-2.9-2.9c-2.5-0.6-5.7-1.1-10.6-2 c-6.1-1.1-7.9-3.6-7.9-6.1c0-4.8,6.6-7,13-7c7.4,0,13.6,2.6,13.6,7.6h-6.2c-0.3-3.1-3.4-4.2-7.7-4.2c-2.9,0-6.5,0.7-6.5,3.1 c0,1.7,1.7,2.6,4.2,3.1c0.5,0.1,8.4,1.5,10.2,1.8c4.7,0.9,6.9,3.6,6.9,6.1c0,5.4-7.1,7.5-14.1,7.5c-8.1,0-14.7-2.6-14.8-8.5H268.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "294.2,208.1 319.7,208.1 319.7,211.7 300.4,211.7 300.4,218 318.3,218 318.3,221.4 300.4,221.4  300.4,228.4 320.1,228.4 320.1,232 294.2,232 294.2,208.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347,215.7c-1-2.7-3.7-4.8-8.9-4.8c-7.6,0-10.8,4.5-10.8,9.1c0,4.6,3.2,9.1,10.8,9.1c5.5,0,8.6-2.8,9.1-6.3 h6.1c-0.5,5.7-6.5,9.7-15.1,9.7c-10.6,0-17-5.7-17-12.5s6.4-12.5,17-12.5c8,0,14.3,3,15.1,8.2H347"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.2,208.1h6.2V222c0,3.2,0.3,6.9,8.4,6.9c8.1,0,8.3-3.7,8.3-6.9v-13.9h6.2v15.3c0,6.1-5.8,9.2-14.6,9.2 c-8.8,0-14.6-3-14.6-9.2V208.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.2,208.1h17c7.8,0,11.7,2.4,11.7,6.5c0,4.6-4.7,5.8-5.9,6v0.1c2.1,0.2,5.3,1.3,5.3,5.1 c0,2.8,0.6,5.3,1.9,6.3h-6.7c-0.9-1-0.9-2.3-0.9-3.5c0-4.4-1.3-6.3-7.1-6.3h-9.1v9.8h-6.2V208.1 M392.5,219h10.2 c3.9,0,6.1-1.3,6.1-3.8c0-3-2.9-3.7-6.2-3.7h-10.1V219z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.2,
    y: 208.1,
    className: "st0",
    width: 6.2,
    height: 23.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "426.3,208.1 455.1,208.1 455.1,211.7 443.8,211.7 443.8,232 437.6,232 437.6,211.7 426.3,211.7  426.3,208.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "467.5,222.6 454.2,208.1 461.4,208.1 470.8,218.8 480,208.1 487,208.1 473.7,222.6 473.7,232  467.5,232 467.5,222.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.9,224.8v5.6h1v-2.2h0.8c0.5,0,0.9,0.1,1.1,0.2c0.4,0.2,0.5,0.6,0.5,1.3v0.4l0,0.2c0,0,0,0,0,0.1 c0,0,0,0,0,0.1h0.9l0-0.1c0,0,0-0.1-0.1-0.3c0-0.1,0-0.3,0-0.4v-0.4c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.3-0.5-0.5-1-0.5 c0.3-0.1,0.6-0.1,0.8-0.3c0.4-0.2,0.5-0.6,0.5-1.1c0-0.7-0.3-1.2-0.9-1.4c-0.3-0.1-0.8-0.2-1.5-0.2H481.9 M485.3,226.5 c0,0.4-0.2,0.7-0.6,0.9c-0.2,0.1-0.5,0.1-1,0.1h-0.9v-2h0.8c0.6,0,1,0.1,1.2,0.2C485.2,225.8,485.3,226.1,485.3,226.5z  M489.1,227.6c0-1.4-0.5-2.6-1.5-3.6c-1-1-2.2-1.5-3.6-1.5c-1.4,0-2.6,0.5-3.6,1.5s-1.5,2.2-1.5,3.6c0,1.4,0.5,2.6,1.5,3.6 c1,1,2.2,1.5,3.6,1.5c1.4,0,2.6-0.5,3.6-1.5C488.6,230.2,489.1,229,489.1,227.6z M483.9,223.2c1.2,0,2.3,0.4,3.1,1.3 c0.9,0.9,1.3,1.9,1.3,3.1c0,1.2-0.4,2.3-1.3,3.1c-0.9,0.9-1.9,1.3-3.1,1.3c-1.2,0-2.3-0.4-3.1-1.3c-0.9-0.9-1.3-1.9-1.3-3.1 c0-1.2,0.4-2.3,1.3-3.1C481.7,223.6,482.7,223.2,483.9,223.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrinksLogo);
export default __webpack_public_path__ + "static/media/brinksLogo.8d8e37b1a328405b6b3cf07d8a7a3ee3.svg";
export { ForwardRef as ReactComponent };